var render = function () {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c('a', {
    staticClass: "weui-tabbar__item",
    class: {
      'weui-bar__item_on': _vm.isActive,
      'vux-tabbar-simple': _vm.simple
    },
    attrs: {
      "href": "javascript:;"
    },
    on: {
      "click": function ($event) {
        return _vm.onItemClick(true);
      }
    }
  }, [!_vm.simple ? _c('div', {
    staticClass: "weui-tabbar__icon",
    class: [_vm.iconClass || _vm.$parent.iconClass, {
      'vux-reddot': _vm.showDot
    }]
  }, [!_vm.simple && !(_vm.hasActiveIcon && _vm.isActive) ? _vm._t("icon") : _vm._e(), !_vm.simple && _vm.hasActiveIcon && _vm.isActive ? _vm._t("icon-active") : _vm._e(), _vm.badge ? _c('sup', [_c('badge', {
    attrs: {
      "text": _vm.badge
    }
  })], 1) : _vm._e()], 2) : _vm._e(), _c('p', {
    staticClass: "weui-tabbar__label"
  }, [_vm._t("label")], 2)]);
};
var staticRenderFns = [];
export { render, staticRenderFns };